import { observer } from 'mobx-react';
import React from 'react';
import { Redirect } from 'react-router';
import LoadingOverlay from '../../common/components/utils/LoadingOverlay';
import { ROUTE_URLS } from '../../common/constants/constants';
import { InitialDependenciesErrors } from '../../common/startup/initial-dependency-store';
import { rootStore } from '../../common/store/root-store';

export const InitialDependenciesGuard: React.FC<React.PropsWithChildren<unknown>> = observer(({ children }) => {
  const { initialDependenciesReady: InitialDependenciesReady, couldNotFetchFrontendStartupData } =
    rootStore.initialDependencyStore;
  if (couldNotFetchFrontendStartupData) {
    if (couldNotFetchFrontendStartupData === InitialDependenciesErrors.USER_NOT_FOUND_ERROR) {
      return <Redirect to={ROUTE_URLS.NO_ACCOUNT_ERROR} />;
    } else if (couldNotFetchFrontendStartupData === InitialDependenciesErrors.WRONG_AUTH_METHOD_ERROR) {
      return <Redirect to={ROUTE_URLS.WRONG_AUTH_METHOD_ERROR} />;
    } else if (couldNotFetchFrontendStartupData === InitialDependenciesErrors.NETWORK_ERROR) {
      return <Redirect to={ROUTE_URLS.SOMETHING_WENT_WRONG} />;
    } else {
      return <Redirect to={ROUTE_URLS.SETUP_ERROR} />;
    }
  }

  if (!InitialDependenciesReady()) {
    return <LoadingOverlay />;
  } else {
    return <>{children}</>;
  }
});
